import React, { useState } from 'react';
import { auth } from '../services/api';
import { requestPasswordReset } from '../services/passwordReset';
import { passwordStrength } from '../services/passwordStrength';
import PasswordStrength from '../components/PasswordStrength';

const Login = ({ onLogin, notice }) => {
  const [isRegister, setIsRegister] = useState(false);
  const [isForgot, setIsForgot] = useState(false);
  const [form, setForm] = useState({ email: '', password: '', confirm: '', full_name: '' });
  const [error, setError] = useState(notice || '');
  const [loading, setLoading] = useState(false);

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    // Inscription : le mot de passe est saisi deux fois, pour éviter une faute de frappe
    if (isRegister && !isForgot) {
      if (!passwordStrength(form.password).valid) { setError('Ce mot de passe n\'est pas assez robuste : suivez les indications sous le champ.'); return; }
      if (form.password !== form.confirm) { setError('Les deux mots de passe ne sont pas identiques.'); return; }
    }
    setLoading(true);
    setError('');
    try {
      if (isForgot) {
        try {
          await requestPasswordReset(form.email);
          // Même message que le compte existe ou non, pour ne pas révéler qui est inscrit.
          setIsForgot(false);
          setError('Si un compte existe pour cette adresse, un email vient de partir. Pensez à jeter un œil dans vos spams.');
        } catch (e) {
          setError(e.message === 'RATE_LIMIT'
            ? 'Trop de demandes. Patientez quelques minutes avant de réessayer.'
            : 'Envoi impossible pour le moment. Réessayez dans un instant.');
        }
      } else if (isRegister) {
        await auth.register({ email: form.email, password: form.password, full_name: form.full_name });
        setIsRegister(false);
        setForm({ ...form, password: '', confirm: '' });
        setError('Compte créé. Un email de confirmation vient de partir : cliquez sur le lien qu\'il contient, puis connectez-vous. Pensez à jeter un œil dans vos spams.');
      } else {
        const res = await auth.login(form);
        localStorage.setItem('nowatt_token', res.data.access_token);
localStorage.setItem('nowatt_refresh_token', res.data.refresh_token);
localStorage.setItem('nowatt_user', res.data.user_id);
        onLogin(res.data);
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur de connexion');
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoWrap}>
          <img src="/favicon_nowatt.png" alt="" style={styles.logoImg} />
          <span style={styles.logo}><span style={styles.accent}>No</span>watt</span>
          <span style={styles.tagline}>Votre électricité au meilleur prix</span>
        </div>
        <h2 style={styles.title}>{isForgot ? 'Mot de passe oublié' : isRegister ? 'Créer un compte' : 'Connexion'}</h2>
        {error && <div style={styles.error}>{error}</div>}
        <form onSubmit={submit} style={styles.form}>
          {isForgot && (
            <p style={styles.hint}>Indiquez l'adresse email de votre compte : vous recevrez un lien pour choisir un nouveau mot de passe.</p>
          )}
          {isRegister && !isForgot && (
            <input style={styles.input} name="full_name" placeholder="Nom complet" onChange={handle} required />
          )}
          <input style={styles.input} name="email" type="email" placeholder="Email" value={form.email} onChange={handle} required />
          {!isForgot && (
            <input style={styles.input} name="password" type="password" autoComplete={isRegister ? 'new-password' : 'current-password'} placeholder="Mot de passe" value={form.password} onChange={handle} required />
          )}
          {isRegister && !isForgot && <PasswordStrength password={form.password} />}
          {isRegister && !isForgot && (
            <input style={styles.input} name="confirm" type="password" autoComplete="new-password" placeholder="Confirmez le mot de passe" value={form.confirm} onChange={handle} required />
          )}
          {!isForgot && !isRegister && (
            <button type="button" style={styles.forgot} onClick={() => { setIsForgot(true); setError(''); }}>
              Mot de passe oublié ?
            </button>
          )}
          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'Chargement...' : isForgot ? 'Recevoir le lien' : isRegister ? 'Créer mon compte' : 'Se connecter'}
          </button>
        </form>
        {isForgot ? (
          <p style={styles.toggle} onClick={() => { setIsForgot(false); setError(''); }}>
            Retour à la connexion
          </p>
        ) : (
          <p style={styles.toggle} onClick={() => { setIsRegister(!isRegister); setError(''); }}>
            {isRegister ? 'Déjà un compte ? Se connecter' : 'Pas de compte ? S\'inscrire'}
          </p>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: '#111620', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  card: { background: '#111620', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 16, padding: '44px 40px', width: '100%', maxWidth: 400 },
  logoWrap: { textAlign: 'center', marginBottom: 32 },
  logoImg: { display: 'block', width: 64, height: 64, objectFit: 'contain', margin: '0 auto 10px' },
  logo: { fontFamily: "'Lexend', sans-serif", fontSize: '2rem', fontWeight: 700, color: '#EEF2FF' },
  accent: { color: '#C8F135' },
  tagline: { display: 'block', fontSize: '0.82rem', color: 'rgba(238,242,255,0.4)', marginTop: 6 },
  title: { fontFamily: "'Lexend', sans-serif", fontSize: '1.3rem', fontWeight: 600, color: '#EEF2FF', marginBottom: 24, textTransform: 'lowercase' },
  error: { background: 'rgba(200,241,53,0.1)', border: '1px solid rgba(200,241,53,0.3)', borderRadius: 8, padding: '10px 14px', fontSize: '0.82rem', color: '#C8F135', marginBottom: 16 },
  form: { display: 'flex', flexDirection: 'column', gap: 12 },
  input: { background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '12px 16px', color: '#EEF2FF', fontSize: '0.9rem', outline: 'none' },
  btn: { background: '#C8F135', color: '#06080C', border: 'none', borderRadius: 8, padding: '13px', fontWeight: 700, fontSize: '0.95rem', cursor: 'pointer', marginTop: 8 },
  forgot: { background: 'none', border: 'none', padding: '2px 0', color: '#C8F135', fontSize: '0.82rem', cursor: 'pointer', textAlign: 'right', alignSelf: 'flex-end' },
  hint: { margin: 0, fontSize: '0.82rem', lineHeight: 1.5, color: 'rgba(238,242,255,0.55)' },
  toggle: { textAlign: 'center', marginTop: 20, fontSize: '0.82rem', color: 'rgba(238,242,255,0.4)', cursor: 'pointer' },
};

export default Login;
